export default __webpack_public_path__ + "static/media/algodao_v4.5f12c5d5.png";